import Axios from "../util/axiosInstance";

export const getCountryApi = () => {
  return Axios.get("/api/Master/Countries");
};
